import { useQueryTemplateCreationRecordById } from '@/features/templateBuilder/hooks/queries/useQueryTemplateCreationRecordById';
import { useQueryTemplateById } from '@/hooks/query/useQueryTemplateById';
import { templateCreationRecordIdAtom } from '@heidi/templates';
import { useAtomValue } from 'jotai';
export const useTemplateFromTemplateCreationRecordId = () => {
  const templateCreationRecordId = useAtomValue(templateCreationRecordIdAtom);
  const { data: templateCreationRecord } = useQueryTemplateCreationRecordById({
    templateCreationRecordId,
    select: (data) => {
      return {
        templateId: data.template_creation_record.template_id,
      };
    },
  });
  const { data: template } = useQueryTemplateById(
    templateCreationRecord?.templateId,
    null
  );
  return template;
};
